import React, { useState } from "react";
import PropTypes from "prop-types";
import { Col, Form, Input, Button } from "reactstrap";
import SpinnerLabel from "common/components/spinner-label";

const propTypes = {
  isProcessing: PropTypes.bool.isRequired,
  isUpdating: PropTypes.bool.isRequired,
  updateCallback: PropTypes.func.isRequired,
  client: PropTypes.shape({
    email: PropTypes.string,
    full_name: PropTypes.string
  }).isRequired
};

const EditClient = ({ updateCallback, isProcessing, isUpdating, client }) => {
  const [clientFullName, setClientFullName] = useState(client.full_name);
  const [clientEmail, setClientEmail] = useState(client.email);

  const formSubmit = event => {
    updateCallback(event, { ...client, ...{ full_name: clientFullName, email: clientEmail } });
  };

  return (
    <Col>
      <Form inline onSubmit={formSubmit}>
        <Input
          onChange={e => setClientFullName(e.target.value)}
          minLength="1"
          maxLength="50"
          required
          placeholder="Enter client name (required)"
          defaultValue={client.full_name}
          id="full_name"
          className="m-1"
        />
        <Input
          onChange={e => setClientEmail(e.target.value)}
          minLength="1"
          maxLength="100"
          required
          placeholder="Enter client's email address (required)"
          type="email"
          id="email"
          defaultValue={client.email}
          className="m-1"
        />
        <Button disabled={isProcessing} color="primary" type="submit" className="m-1 btn-sharp">
          <SpinnerLabel spin={isUpdating} label="Update" />
        </Button>
      </Form>
    </Col>
  );
};

EditClient.propTypes = propTypes;

export default EditClient;
